// extracted by mini-css-extract-plugin
export default {"additionalOrdersList":"AdditionalOrdersList_additionalOrdersList__x06JX","listItem":"AdditionalOrdersList_listItem__m-uPf","checkbox":"AdditionalOrdersList_checkbox__VZ63M"};